import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { useNavigate } from "react-router-dom";

const QuickNavigation = () => {
  const navigationCards = [
    {
      title: "Talleres",
      description: "Participa en talleres de astrología, numerología, desarrollo emocional, entre otros. Espacios de aprendizaje y crecimiento personal guiados por la doctora.",
      path: "/historical-research-archive",
      icon: "Users",
      image: "/assets/images/talleres_1.jpg",
      color: "from-green-500/10 to-green-600/10",
      iconColor: "text-green-600",
    },
    {
      title: "Entrevistas",
      description: "Accede a entrevistas ofrecidas por la autora en prensa, televisión y medios digitales.",
      path: "/interviews",
      icon: "Tv",
      image: "/assets/images/entrevistas_1.jpg",
      color: "from-blue-500/10 to-blue-600/10",
      iconColor: "text-blue-600",
    },
      {
          title: "Oraciones",
          description: "Encuentra oraciones de protección, sanación y fortaleza espiritual.",
          path: null,
          icon: "Heart",
          image: "/assets/images/rezar.webp",
          color: "from-amber-500/10 to-amber-600/10",
          iconColor: "text-amber-600",
      }
  ];
    const [isPrayerListOpen, setIsPrayerListOpen] = useState(false);
    const [activePrayer, setActivePrayer] = useState(null);
    const prayers = {
        "Virgen de Lourdes":"¡Oh amabilísima Virgen de Lourdes, Madre de Dios y Madre nuestra!\n" +
            "Llenos de aflicción y con lágrimas fluyendo de los ojos,\n" +
            "acudimos en las horas amargas de la enfermedad a tu maternal corazón,\n" +
            "para pedirte que derrames a manos llenas¿\n" +
            "el tesoro de tu misericordia sobre nosotros.\n" +
            "\n" +
            "Indignos somos por nuestros pecados de que nos escuches,\n" +
            "Pero acuérdate que jamás se ha oído decir\n" +
            "que ninguno de los que han acudido a ti haya sido abandonado.\n" +
            "\n" +
            "¡Madre tierna! ¡Madre bondadosa! ¡Madre dulcísima!\n" +
            "Ya que Dios obra por tu mano curaciones sin cuento en la Gruta prodigiosa de Lourdes,\n" +
            "sanando tantas víctimas del dolor,\n" +
            "guarda también una mirada de bendición para nuestro pobre enfermo… (se dice el nombre).\n" +
            "\n" +
            "Alcanzadle de vuestro Divino Hijo Jesucristo la deseada salud,\n" +
            "si ha de ser para mayor gloria de Dios.\n" +
            "Pero mucho más alcanzadnos a todos el perdón de nuestros pecados,\n" +
            "paciencia y resignación en los sufrimientos\n" +
            "y sobre todo un amor grande y eterno a nuestro Dios,\n" +
            "prisionero por nosotros en los Sagrarios. Amén.\n" +
            "\n" +
            "Virgen de Lourdes, rogad por nosotros.\n" +
            "Consuelo de los afligidos, rogad por nosotros.\n" +
            "Salud de los enfermos, rogad por nosotros.",
        "San Benito":"“Oh glorioso San Benito, modelo sublime de todas las virtudes, vaso puro de la gracia de Dios.\n" +
            "\n" +
            "Heme aquí, humildemente postrado ante ti. Imploro tu corazón lleno de amor para que intercedas por mí ante el trono divino de Dios.\n" +
            "\n" +
            "A ti recurro en todos los peligros que a diario me rodean.\n" +
            "\n" +
            "Protégeme contra mis enemigos, contra el maligno enemigo en todas sus formas e inspírame a imitarte en todas las cosas\n" +
            "\n" +
            "Que tu bendición esté conmigo siempre, de modo que pueda huir de todo lo que no es agradable a Dios y evitar así las ocasiones de pecado.\n" +
            "\n" +
            "Dulcemente te pido, que me consigas de Dios los favores y gracias de las cuales yo estoy tan necesitado, en las pruebas, en las miserias y en las aflicciones de la vida.\n" +
            "\n" +
            "Tu corazón siempre estuvo tan lleno de amor, compasión y misericordia hacia los que estaban afligidos o con problemas de cualquier tipo.\n" +
            "\n" +
            "Tú nunca has despedido sin consuelo y asistencia a cualquiera que haya recurrido a ti. Por lo tanto, invoco tu poderosa intercesión, con esperanza y confiado en que tú escucharás mis oraciones y me alcanzarás la gracia especial y favor que tan seriamente te imploro (pedir el favor a recibir), si es para la mayor gloria de Dios y el bien de mi alma.\n" +
            "\n" +
            "Ayúdame, Oh gran San Benito, vivir y morir como un hijo fiel de Dios, que sea siempre sumiso a Su santa voluntad, para lograr la felicidad eterna del cielo. Amén.”",
        "Preciosa Sangre de Cristo":"Señor Jesús, en tu nombre y con el Poder de tu Sangre preciosa sellamos toda persona, hechos o acontecimientos a través de los cuales el enemigo nos quiera hacer daño.\n" +
            "Con el Poder de la Sangre de Jesús sellamos toda potestad destructora en el aire, en la tierra, en el agua, en el fuego, debajo de la tierra, en las fuerzas satánicas de la naturaleza, en los abismos del infierno, y en el mundo en el cual nos movemos hoy.\n" +
            "\n" +
            "Con el Poder de la Sangre de Jesús, rompemos toda acción del maligno. Te pedimos Jesús que envíes a nuestros hogares y lugares de trabajo a la Santísima Virgen, Con los Ángeles San Miguel, San Gabriel, San Rafael.\n" +
            "\n" +
            "Con el Poder de la Sangre de Jesús sellamos nuestra casa, todos los que la habitan (nombrar a cada uno de ellos), las personas que llegan a ella. Los alimentos y los bienes para nuestro sustento.\n" +
            "Con el Poder de la Sangre de Jesús sellamos los lugares donde vamos a estar este día, y las personas, con quienes vamos a tratar.\n" +
            "\n" +
            "Con el Poder de la Sangre de Jesús sellamos nuestro trabajo material y espiritual, los negocios familiares. Los vehículos, las carreteras, las vías que utilicemos, los objetos, paredes, puertas y el aire que respiramos, y en fe colocamos un círculo de tu Sangre alrededor de toda nuestra familia.\n" +
            "\n" +
            "Te agradecemos, Señor, por Tu Sangre y por Tu Vida, ya que gracias a ellas hemos sido salvados y somos preservados de todo mal. Amén",
        "Padre Pio":"Has venido a visitarme,\n" +
            "como Padre y como Amigo.\n" +
            "Jesús, no me dejes solo.\n" +
            "¡Quédate, Señor, conmigo!\n" +
            "\n" +
            "Por el mundo envuelto en sombras\n" +
            "voy errante peregrino.\n" +
            "Dame tu luz y tu gracia.\n" +
            "¡Quédate, Señor, conmigo!\n" +
            "\n" +
            "En este precioso instante\n" +
            "abrazado estoy contigo.\n" +
            "Que esta unión nunca me falte.\n" +
            "¡Quédate, Señor, conmigo!\n" +
            "\n" +
            "Acompáñame en la vida.\n" +
            "Tu presencia necesito.\n" +
            "Sin Ti desfallezco y caigo.\n" +
            "¡Quédate, Señor, conmigo!\n" +
            "\n" +
            "Declinando está la tarde.\n" +
            "Voy corriendo como un río\n" +
            "al hondo mar de la muerte.\n" +
            "¡Quédate, Señor, conmigo!\n" +
            "\n" +
            "En la pena y en el gozo\n" +
            "sé mi aliento mientras vivo,\n" +
            "hasta que muera en tus brazos.\n" +
            "¡Quédate, Señor, conmigo!"
    }
    const navigate = useNavigate();

    return (
    <section className="pt-8 sm:pt-12 lg:pt-24 pb-8 lg:pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">

          <h2 className="font-headline text-3xl lg:text-4xl font-bold text-primary mb-4">
            Explora los servicios de la Doctora
          </h2>

          <p className="font-body text-lg text-primary max-w-3xl mx-auto">
            Descubre servicios de la autora, desde talleres astrológicos y emocionales hasta
            tours nacionales y mundiales de sanación.
          </p>
        </div>

        {/* Main Navigation Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {navigationCards?.map((card, index) => (
              <button
                  onClick={() => {
                      if (card.title === "Oraciones") {
                          setIsPrayerListOpen(true);
                      }else if (card.path) {
                          navigate(card.path);
                      }
                  }}
                  className="group bg-card rounded-2xl literary-shadow overflow-hidden literary-transition hover:literary-shadow-elevated hover:-translate-y-1 flex flex-col"
              >
                {/* Card Image */}
                <div className="relative h-48 overflow-hidden">
                  <Image
                      src={card?.image}
                      alt={card?.title}
                      className="w-full h-full object-cover sepia-overlay group-hover:scale-105 literary-transition"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${card?.color} to-transparent`} />
                  <div className="absolute top-4 left-4">
                    <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center literary-shadow">
                      <Icon name={card?.icon} size={24} className={card?.iconColor} />
                    </div>
                  </div>
                </div>

                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-headline text-xl font-bold text-primary mb-3 group-hover:text-burnished-copper literary-transition">
                    {card?.title}
                  </h3>

                  <p className="font-body text-foreground text-sm leading-relaxed mb-4">
                    {card?.description}
                  </p>

                    {card?.path && (
                        <div className="flex items-center space-x-2 text-primary group-hover:text-burnished-copper literary-transition mt-auto">
                            <span className="font-cta text-sm font-medium">Explorar</span>
                            <Icon name="ArrowRight" size={16} className="group-hover:translate-x-1 literary-transition" />
                        </div>
                    )}
                </div>
              </button>
          ))}
        </div>
      </div>
        {isPrayerListOpen && (
            <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4">
                <div className="bg-background rounded-2xl max-w-md w-full p-6">
                    <h3 className="font-headline text-2xl font-bold text-primary mb-4 text-center">
                        Oraciones
                    </h3>

                    <div className="space-y-3">
                        {Object.keys(prayers).map((name) => (
                            <button
                                key={name}
                                onClick={() => {
                                    setActivePrayer(name);
                                    setIsPrayerListOpen(false);
                                }}
                                className="w-full text-left px-4 py-3 rounded-lg bg-primary/5 hover:bg-primary/10 literary-transition font-body"
                            >
                                {name}
                            </button>
                        ))}
                    </div>

                    <button
                        onClick={() => setIsPrayerListOpen(false)}
                        className="mt-6 w-full text-sm text-primary hover:underline"
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        )}
        {activePrayer && (
            <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center px-4">
                <div className="bg-background rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6">
                    <h3 className="font-headline text-2xl font-bold text-primary mb-4 text-center">
                        {activePrayer}
                    </h3>

                    <pre className="font-body text-foreground whitespace-pre-wrap leading-relaxed">
        {prayers[activePrayer]}
      </pre>

                    <button
                        onClick={() => setActivePrayer(null)}
                        className="mt-6 w-full text-sm text-primary hover:underline"
                    >
                        Cerrar oración
                    </button>
                </div>
            </div>
        )}

    </section>
  );
};

export default QuickNavigation;